import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import { ReportFilterModel } from '../../components/Report/ReportFilter';
import ReportFilters from '../../components/Report/ReportFilters';
import ReportData from '../../components/Report/ReportData';

type ReportModel = {
  name: string;
  title: string;
  filters: ReportFilterModel[];
};

export default function ReportsShow() {
  const { report: reportName } = useParams();

  const [isFiltersLoading, setIsFiltersLoading] = useState(true);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [reportFilters, setReportFilters] = useState<ReportModel>();
  const [reportData, setReportData] = useState<any | undefined>();
  const [formErrors, setFormErrors] = useState({});

  const {
    user: { organization },
  } = useAuth();

  async function getReportFilters() {
    if (organization) {
      setIsFiltersLoading(true);
      const { data } = await api.get(
        `organizations/${organization.id}/reports/${reportName}/filters`
      );
      setReportFilters(data);
      setIsFiltersLoading(false);
    }
  }

  async function getReportData(filters: any) {
    if (organization) {
      setIsDataLoading(true);
      try {
        const { data } = await api.post(
          `organizations/${organization.id}/reports/${reportName}/data`,
          { ...filters }
        );
        setReportData(data);
        setFormErrors([]);
      } catch (e: any) {
        if (e?.response?.data?.errors) {
          setFormErrors(e.response.data.errors);
        } else {
          throw e;
        }
      }
      setIsDataLoading(false);
    }
  }

  useEffect(() => {
    getReportFilters();
  }, [organization]);

  const onSubmit = (filters: any) => {
    getReportData(filters);
  };

  return isFiltersLoading ? (
    <span>Carregando</span>
  ) : (
    <div>
      <header>
        <h1>{reportFilters?.title}</h1>
      </header>
      <main>
        <ReportFilters
          filters={reportFilters?.filters || []}
          onSubmit={onSubmit}
          formErrors={formErrors}
        />
        {reportData && <hr />}
        <ReportData isLoading={isDataLoading} data={reportData} />
      </main>
    </div>
  );
}
